import React from "react";
import trans from "../../../../utils";
import { useNavigate } from "react-router-dom";

export default function OfflineSetupControlHeader() {
	const navigate = useNavigate();
	return (
		<div
			className="setup-header"
			style={{ height: "auto", paddingBlock: "16px" }}
		>
			<div>
				<div
					style={{
						fontWeight: "600",
						color: "#000000E0",
						fontSize: "16px",
						marginBottom: "2px",
					}}
				>
					{trans(`Set-Up Configuration`)}
				</div>
				<div style={{ fontWeight: "500", color: "#42526E", fontSize: "12px" }}>
					{trans(`Select the Data to Use in your offline Mode`)}
				</div>
			</div>
			<div
				className="setup-header-tool"
				onClick={() => navigate("/setup/offline-setup")}
			>
				<img src={`${process.env.PUBLIC_URL}/assets/Close.svg`} alt="back" />
			</div>
		</div>
	);
}
